// tanstack
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

// material ui
import { Box, Stack } from '@mui/material';

// api
import { useGetAccountByIdQuery } from '@/api/recalc/endpoints/accountsApiSlice';

// feature-components
import ServiceTabs from '@/features/service-manager/components/ServiceTabs';

export const Route = createFileRoute('/$accountId/_user/account/services')({
  component: RouteComponent,
});

function RouteComponent() {
  const { accountId } = useParams({
    from: '/$accountId/_user/account/services',
  });

  const { data: account } = useGetAccountByIdQuery(accountId);

  return (
    <>
      <Stack spacing={2}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', lg: 'row' },
            gap: 2,
            alignItems: 'stretch',
          }}
        >
          <Box
            sx={{
              width: { xs: '100%', lg: 320 },
              flexShrink: 0,
            }}
          >
            <ServiceTabs
              account={account}
              orientation="vertical"
              accountId={accountId}
              selectedAccountId={accountId}
              routePrefix="account/services"
            />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Outlet />
          </Box>
        </Box>
      </Stack>
    </>
  );
}
